import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  videoContainer: {
    backgroundColor: "#0A0A0A",
    width: "100%",
    paddingTop: "100px",
    paddingBottom: "100px",
  },
  inlineContainer: {
    width: "100%",
    maxWidth: "520px",
    margin: "0 auto 24px",
  },
  sectionTitle: {
    color: "#FFFFFF",
    fontWeight: 700,
    marginBottom: "60px",
    position: "relative",
    display: "inline-block",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "-12px",
      left: 0,
      width: "60px",
      height: "4px",
      background: "#00FF41",
      borderRadius: "2px",
    },
  },
  videoFrame: {
    position: "relative",
    width: "100%",
    paddingTop: "56.25%",
    borderRadius: "12px",
    border: "1px solid #2A2A2A",
    background: "#141414",
    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.35)",
    overflow: "hidden",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "#00FF41",
      boxShadow: "0 22px 44px rgba(0, 255, 65, 0.12)",
    },
    [theme.breakpoints.down("xs")]: {
      borderRadius: "8px",
    },
  },
  iframe: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    border: 0,
  },
}));

function getLoomEmbedUrl(loomUrl) {
  if (!loomUrl) {
    return "";
  }

  const trimmedUrl = loomUrl.trim();

  if (!trimmedUrl) {
    return "";
  }

  try {
    const url = new URL(trimmedUrl);
    const loomMatch = url.pathname.match(/\/(?:share|embed)\/([^/?#]+)/);

    if (loomMatch) {
      return `https://www.loom.com/embed/${loomMatch[1]}`;
    }
  } catch (error) {
    return "";
  }

  return "";
}

export default function LoomVideo({
  loomUrl,
  sectionId = "IntroVideo",
  title = "",
  iframeTitle = "Berkley Olmstead intro video",
  inline = false,
  inlineMaxWidth = "",
  inlineMargin = "",
}) {
  const classes = useStyles();
  const embedUrl = getLoomEmbedUrl(loomUrl);

  if (!embedUrl) {
    return null;
  }

  const video = (
    <>
      {title ? (
        <Typography variant="h4" className={classes.sectionTitle}>
          {title}
        </Typography>
      ) : null}
      <div className={classes.videoFrame}>
        <iframe
          src={embedUrl}
          title={iframeTitle}
          className={classes.iframe}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    </>
  );

  if (inline) {
    const inlineStyle = {
      ...(inlineMaxWidth ? { maxWidth: inlineMaxWidth } : {}),
      ...(inlineMargin ? { margin: inlineMargin } : {}),
    };

    return (
      <div
        id={sectionId}
        className={classes.inlineContainer}
        style={Object.keys(inlineStyle).length ? inlineStyle : undefined}
      >
        {video}
      </div>
    );
  }

  return (
    <Grid item xs={12} id={sectionId} className={classes.videoContainer}>
      <Container maxWidth="md">{video}</Container>
    </Grid>
  );
}
